import { MultiSelect } from 'Shared/forms/Inputs';
import { useStore, cloneSw, StoreProvider } from 'Shared/StoreProvider';
import { useActiveStyles } from 'Shared/backend/ActiveStylesContext';
import { useSite } from 'Shared/SiteProvider';
import { VenueSettingsFactory } from 'Shared/VenueSettingsFactory';
import { createMemo } from 'solid-js';


export function CancelStylesUi()
{
	const sw = useStore();
	const parentSw = { ...cloneSw(sw), location: (sw.location ?? []).slice(0, -3) };

	const siteTheme = (new VenueSettingsFactory()).createSettings(useSite().key).siteTheme();

	const parentActiveStyles = useActiveStyles();

	/* Navigate to the parent store position to read currently-cancelled styles. */
	const parentStorePos = () => {
		let pos: any = parentSw.store;
		for (const part of parentSw.location) pos = pos?.[part];
		return pos;
	};

	/*
		Always include currently-cancelled styles in the options even if they're no longer in
		parentActiveStyles (which filters them out once cancelled). Without this, MultiSelect
		auto-removes the selection when the option disappears from the list.
	*/
	const options = createMemo(() => {
		const active = parentActiveStyles();
		const cancelled = (parentStorePos()?.removeStyles ?? []) as string[];

		const ret: Record<string, string> = {};
		for (const s of [...active, ...cancelled]) {
			if (siteTheme.styles[s]?.category !== 'tools')
				ret[s] = s;
		}
		return ret;
	});

	return (
		<StoreProvider {...parentSw}>
			<MultiSelect field='removeStyles' options={options()} />
		</StoreProvider>
	);
}
